import { uid } from '../utils/helpers.js';
import { MC } from '../utils/constants.js';

export class SessionManager {
  constructor(cfg) {
    this.cfg   = cfg;
    this._sKey = `${MC.STORAGE_KEY}_${cfg.appId}`;
    this._hKey = `${MC.HISTORY_KEY}_${cfg.appId}`;
    this._pKey = `${MC.PREFS_KEY}_${cfg.appId}`;
  }

  getOrCreate() {
    let s = this._load(this._sKey);
    if (!s || !s.sessionId) {
      s = {
        sessionId:        uid('s'),
        userId:           this.cfg.userId           || uid('u'),
        userName:         this.cfg.userName         || '',
        userEmail:        this.cfg.userEmail        || '',
        userBusinessName: this.cfg.userBusinessName || '',
        userAvatar:       this.cfg.userAvatar       || '',
        appId:            this.cfg.appId,
        entryUrl:         location.href,
        createdAt:        Date.now(),
      };
    }
    if (this.cfg.userId)           s.userId           = this.cfg.userId;
    if (this.cfg.userName)         s.userName         = this.cfg.userName;
    if (this.cfg.userEmail)        s.userEmail        = this.cfg.userEmail;
    if (this.cfg.userBusinessName) s.userBusinessName = this.cfg.userBusinessName;
    if (this.cfg.userAvatar)       s.userAvatar       = this.cfg.userAvatar;
    s.lastSeen = Date.now();
    this._save(this._sKey, s);
    return s;
  }

  getHistory()    { return this._load(this._hKey) || []; }
  getPrefs()      { return this._load(this._pKey) || {}; }
  setPrefs(patch) { this._save(this._pKey, { ...this.getPrefs(), ...patch }); }

  appendHistory(msg) {
    if (!this.cfg.persistHistory) return;
    const h = this.getHistory();
    h.push(msg);
    if (h.length > this.cfg.maxHistory) h.splice(0, h.length - this.cfg.maxHistory);
    this._save(this._hKey, h);
  }

  updateLastMessage(id, text) {
    const h = this.getHistory();
    const m = h.find(x => x.id === id);
    if (m) { m.text = text; this._save(this._hKey, h); }
  }

  clearHistory()  { localStorage.removeItem(this._hKey); }
  clearSession()  { localStorage.removeItem(this._sKey); }

  _cacheKey(sessionId) { return `mc_hist_cache_${this.cfg.appId}_${sessionId}`; }

  getHistoryCache(sessionId) {
    const raw = this._load(this._cacheKey(sessionId));
    if (!raw || !raw.cached_at) return null;
    if (Date.now() - raw.cached_at > 4 * 60 * 60 * 1000) return null;
    return raw.messages || [];
  }

  setHistoryCache(sessionId, messages) {
    this._save(this._cacheKey(sessionId), { messages, cached_at: Date.now() });
  }

  clearHistoryCache(sessionId) {
    try { localStorage.removeItem(this._cacheKey(sessionId)); } catch {}
  }

  _lookupKey(email) { return `mc_user_lookup_${this.cfg.appId}_${encodeURIComponent(email)}`; }

  getUserLookup(email) {
    const raw = this._load(this._lookupKey(email));
    if (!raw || !raw.cached_at) return null;
    if (Date.now() - raw.cached_at > 4 * 60 * 60 * 1000) return null;
    return raw;
  }

  setUserLookup(email, externalUserId) {
    this._save(this._lookupKey(email), { external_user_id: externalUserId, cached_at: Date.now() });
  }

  patchUserId(userId) {
    const s = this._load(this._sKey) || this.getOrCreate();
    s.userId   = userId;
    s.lastSeen = Date.now();
    this._save(this._sKey, s);
    return s;
  }

  setActiveSession(newSessionId) {
    const s = this.getOrCreate();
    s.sessionId = newSessionId;
    s.lastSeen  = Date.now();
    this._save(this._sKey, s);
  }

  _uid(prefix = 'x') { return uid(prefix); }
  _load(k)   { try { return JSON.parse(localStorage.getItem(k)); } catch { return null; } }
  _save(k, v){ try { localStorage.setItem(k, JSON.stringify(v)); } catch {} }
}
